import { EpimsBaseEntityDto } from './epim-base.dto';
export class ObligationFacilityDto extends EpimsBaseEntityDto {

   ObligationFacilityName: string;
   Remarks: string;
   CountryId: string;
   StateId: string;
   LgaId: string;
   CreatedStaff: string;
   DateCreated:	Date;
   SubscriptionUserId: string;
   LandTitleId: string;
   FacilityId: string;

}
